module.exports = __webpack_public_path__ + "static/dash-ac9002ba9b85d1c02a419499251c1297.png";